import { type FunctionComponent } from 'react'
import { type SelectChangeEvent } from '@mui/material'
import useIntl from '@/utils/intl'
import LocationSelect from '../LocationSelect'
import { type City, type District, type SelectItem } from '@/lib/network-coverage-v2/types'

interface WifiTabProps {
  selectedCity: City | null
  selectedDistrict: District | null
  districts: District[]
  cityItems: SelectItem[]
  districtItems: SelectItem[]
  iconColor: string
  onCitySelect: (zipcode: string) => void
  onDistrictSelect: (zipcode: string) => void
}

const WifiTab: FunctionComponent<WifiTabProps> = ({
  selectedCity,
  selectedDistrict,
  districts,
  cityItems,
  districtItems,
  iconColor,
  onCitySelect,
  onDistrictSelect
}) => {
  const { translate } = useIntl()

  const handleCitySelect = (event: SelectChangeEvent<string>): void => {
    onCitySelect(event.target.value)
  }

  const handleDistrictSelect = (event: SelectChangeEvent<string>): void => {
    onDistrictSelect(event.target.value)
  }

  return (
    <div className='p-6 border-b border-secondaryMidStroke'>
      <LocationSelect
        label={translate('city')}
        value={selectedCity?.zipcode ?? ''}
        items={cityItems}
        onChange={handleCitySelect}
        iconColor={iconColor}
      />
      {selectedCity !== null && (districts?.length ?? 0) > 0 && (
        <LocationSelect
          label={translate('district')}
          value={selectedDistrict?.zipcode ?? ''}
          items={districtItems}
          onChange={handleDistrictSelect}
          iconColor={iconColor}
        />
      )}
    </div>
  )
}

export default WifiTab
